import {
  getNicknameAndUrl,
  getScreenName,
  getSkuType,
} from '../../../Utils/helper';
import { getPriceParams } from '../../../Utils/productPageUtils';
import { getCountry } from '../../../Utils/ForeignUtils';
import { fireEvent } from '../../../Utils/fireEvent';

export const ViewedCartOverlayEvent = (cartData) => {
  const { pricing_param, conversion_param } = getPricingAndConversionParamsPage(
    cartData?.priceDetails,
  );
  const { productIds, productNames } = getProductIdsAndName(
    cartData?.cart_products,
  );
  const productDetails = getNicknameAndUrl(cartData);
  fireEvent({
    category: 'viewed_cart_overlay',
    screen_name: getScreenName(),
    id: productIds,
    name: productNames,
    conversion_param: conversion_param,
    pricing_param: pricing_param,
    sku_nickname: productDetails?.nickName,
    sku_type: getSkuType(cartData?.cart_products[0]?.type),
  });
};
export const UpdateQuantityEvent = (
  productData,
  type,
  quantity,
  cart_filler_product,
) => {
  const { pricingParam } = getPriceParams(productData);
  let product_quantity =
    type === '+' ? quantity + 1 : type == '-' ? quantity - 1 : 0;
  fireEvent({
    category: 'update_quantity',
    screen_name: getScreenName(),
    id: productData.id,
    support_variable: product_quantity,
    cta: type,
    pricing_param: pricingParam,
    display_type: 'overlay',
    cart_filler_product: cart_filler_product,
    // conversion_param:conversionParam
  });
};
export const proccedToPayEvent = (cartData) => {
  const { productIds, productNames, productNickName } = getProductIdsAndName(
    cartData?.cart_products,
  );
  const { pricing_param, conversion_param } = getPricingAndConversionParamsPage(
    cartData?.priceDetails,
  );

  fireEvent({
    category: 'clicked_proceed_to_pay',
    screen_name: getScreenName(),
    id: productIds,
    name: productNames,
    conversion_param: conversion_param,
    pricing_param: pricing_param,
    sku_type: getSkuType(cartData?.cart_products[0]?.type),
    sku_nickname: productNickName,
    display_type: 'overlay',
    support_variable: `{coupon_applied: ${
      cartData?.user_offers?.offers.length > 0 ? 1 : 0
    }}`,
    country: getCountry(),
    // conversion_param:conversionParam
  });
};
export const servedCouponSectionEvent = (coupons) => {
  let offer_term_ids = getTermIdString(coupons);
  fireEvent({
    category: 'served_availiable_offers_section',
    screen_name: getScreenName(),
    display_type: 'overlay',
    support_variable: `{offers_served: ${offer_term_ids},num_coupons: ${coupons?.length}}`,
  });
};
export const applyCouponEvent = (couponDetail) => {
  fireEvent({
    category: 'coupon_applied',
    screen_name: getScreenName(),
    display_type: 'overlay',
    coupon_id: couponDetail?.offer_id,
    term_id: couponDetail?.term_id,
    offer_name: couponDetail?.name,
  });
};

export const getTermIdString = (coupons) => {
  return coupons?.map((item) => item?.term_id).toString();
};

export const getProductIdsAndName = (cart_products, sendCompleteData) => {
  let productIds = '';
  let productNames = '';
  let productNickName = '';

  cart_products?.forEach((item) => {
    if (item?.offered_product) {
      item?.offered_product?.forEach((offerItem) => {
        productIds = updateIdOrName(offerItem.id, productIds);
        productNames = updateIdOrName(offerItem.name, productNames);
        productNickName = updateIdOrName(offerItem.nickname, productNickName);
      });
    } else {
      productIds = updateIdOrName(item.id, productIds);
      productNames = updateIdOrName(item.name, productNames);
      productNickName = updateIdOrName(item.nickname, productNickName);
    }
  });
  if (sendCompleteData) {
    return { productIds, productNames, productNickName };
  }
  productIds = checkLength(productIds);
  productNames = checkLength(productNames);
  return { productIds, productNames, productNickName };
};
const updateIdOrName = (productData, productIds) => {
  if (productData) {
    productIds = productIds + productData + ',';
  }
  return productIds;
};

const checkLength = (productData) => {
  if (productData.length > 99) {
    return productData.slice(0, 99);
  } else {
    return productData.slice(0, productData.length - 1);
  }
};
export const getPricingAndConversionParamsPage = (priceDetails) => {
  let pricing_param =
    priceDetails?.orderMrpTotal +
    ', ' +
    priceDetails?.orderFinalPriceTotal +
    ', ' +
    'NA' +
    ', ' +
    'NA';
  let conversion_param =
    priceDetails?.orderPriceTotal +
    ', ' +
    priceDetails?.orderDeliveryTotal +
    ', ' +
    priceDetails?.orderFinalPriceTotal;
  return { pricing_param, conversion_param };
};

export const fireClickedCouponFieldEvent = (productIds) => {
  fireEvent({
    category: 'clicked_coupon_field',
    screen_name: getScreenName(),
    display_type: 'overlay',
    id: productIds,
  });
};

export const fireEnteredCouponEvent = (productIds, value, auto_fetched = 0) => {
  fireEvent({
    category: 'entered_coupon_code',
    screen_name: getScreenName(),
    display_type: 'overlay',
    id: productIds,
    value: value,
    auto_fetched: auto_fetched,
  });
};

export const firecartFiller = (category, data) => {
  const { pricingParam, conversionParam } = getPriceParams(data?.product);
  fireEvent({
    category: category,
    screen_name: getScreenName(),
    id: data?.product?.id,
    sku_name: data?.product?.name,
    section_name: data?.sectionName,
    parent: 'Cart Filler',
    sku_nickname: data?.nickname,
    page_url: window.location.href,
    conversion_param: conversionParam,
    pricing_param: pricingParam,
  });
};

export const clicked_apply_coupon_event = (data) => {
  fireEvent({
    category: 'clicked_apply_coupon',
    screen_name: getScreenName(),
    term_id: data?.code,
  });
};

export const served_cart_filler_event = (cartFillerProducts) => {
  const ids = cartFillerProducts.map((product) => product.id).join(',');
  fireEvent({
    category: 'served_section_on_cart_overlay',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    section_name: 'Users also Bought',
    card_ids: ids,
  });
};

export const clicked_card_overlay = (section_name, cta) => {
  fireEvent({
    category: 'clicked_card_in_cart_overlay',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    section_name: section_name,
    cta: cta,
  });
};

export const clicked_cart_image = (product_id, web_url) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    cta: 'product_image',
    id: product_id,
    deeplink_value: web_url,
  });
};
